import React, { JSX } from 'react';
import { Badge, Button, Flex, Spinner, Table, Tbody, Td, Text, Th, Thead, Tr } from '@chakra-ui/react';
import { ErrorMessages, MainPageContent, PageHeading } from 'common/components';
import { useExecuteWithConfirmation } from 'common/utils';

import { useCronJobsList, useRunCronJob } from '../../services/cron-jobs';

const CronJobs = (): JSX.Element => {
  const { data: cronJobs, isLoading, error } = useCronJobsList();
  const {
    mutate: runJob,
    isLoading: isRunning,
    error: runError,
    data: runResult,
    variables: runningJob,
  } = useRunCronJob();

  const { executeWithConfirmation: onRunJob } = useExecuteWithConfirmation(
    'Are you sure you want to run this cron job?',
    runJob,
  );

  return (
    <MainPageContent>
      <PageHeading>Cron Jobs</PageHeading>
      <ErrorMessages errors={[error, runError]} />
      {runResult && (
        <Badge colorScheme="green" mb={4} p={2} fontSize="sm">
          Job &quot;{runResult.name}&quot; completed successfully
        </Badge>
      )}
      {isLoading ? (
        <Flex justifyContent="center" p={8}>
          <Spinner />
        </Flex>
      ) : (
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th>Name</Th>
              <Th>Description</Th>
              <Th>Actions</Th>
            </Tr>
          </Thead>
          <Tbody>
            {cronJobs?.map((job) => (
              <Tr key={job.name}>
                <Td fontWeight="medium">{job.name}</Td>
                <Td>
                  <Text color="gray.600">{job.description}</Text>
                </Td>
                <Td>
                  <Button
                    size="sm"
                    colorScheme="blue"
                    onClick={() => onRunJob(job.name)}
                    isLoading={isRunning && runningJob === job.name}
                    isDisabled={isRunning}
                  >
                    Run
                  </Button>
                </Td>
              </Tr>
            ))}
            {cronJobs?.length === 0 && (
              <Tr>
                <Td colSpan={3} textAlign="center" color="gray.500">
                  No cron jobs available
                </Td>
              </Tr>
            )}
          </Tbody>
        </Table>
      )}
    </MainPageContent>
  );
};

export default CronJobs;
